import axios from 'axios';
import { baseURL } from './types';

export const FETCH_BLOG_METRICS_REQUEST = 'FETCH_BLOG_METRICS_REQUEST';
export const FETCH_BLOG_METRICS_SUCCESS = 'FETCH_BLOG_METRICS_SUCCESS';
export const FETCH_BLOG_METRICS_FAIL = 'FETCH_BLOG_METRICS_FAIL';

export const CREATE_BLOG_METRIC_REQUEST = 'CREATE_BLOG_METRIC_REQUEST';
export const CREATE_BLOG_METRIC_SUCCESS = 'CREATE_BLOG_METRIC_SUCCESS';
export const CREATE_BLOG_METRIC_FAIL = 'CREATE_BLOG_METRIC_FAIL';

export const UPDATE_BLOG_METRIC_REQUEST = 'UPDATE_BLOG_METRIC_REQUEST';
export const UPDATE_BLOG_METRIC_SUCCESS = 'UPDATE_BLOG_METRIC_SUCCESS';
export const UPDATE_BLOG_METRIC_FAIL = 'UPDATE_BLOG_METRIC_FAIL';

export const DELETE_BLOG_METRIC_REQUEST = 'DELETE_BLOG_METRIC_REQUEST';
export const DELETE_BLOG_METRIC_SUCCESS = 'DELETE_BLOG_METRIC_SUCCESS';
export const DELETE_BLOG_METRIC_FAIL = 'DELETE_BLOG_METRIC_FAIL';
const API_URL = `${baseURL}/api/appointmentDoctorBlogsReviewRouter`;

const getAuthConfig = () => {
  const token = localStorage.getItem('token');
  const config = { headers: { 'Content-Type': 'application/json' } };
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
};

export const fetchBlogMetrics = () => async (dispatch) => {
  dispatch({ type: FETCH_BLOG_METRICS_REQUEST });
  try {
    const response = await axios.post(`${API_URL}/getall`, {}, getAuthConfig());
    dispatch({ type: FETCH_BLOG_METRICS_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({
      type: FETCH_BLOG_METRICS_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const createBlogMetric = (payload) => async (dispatch) => {
  dispatch({ type: CREATE_BLOG_METRIC_REQUEST });
  try {
    const response = await axios.post(`${API_URL}/create`, payload, getAuthConfig());
    dispatch({ type: CREATE_BLOG_METRIC_SUCCESS, payload: response.data });
    return response; // Add return here for chaining
  } catch (error) {
    dispatch({
      type: CREATE_BLOG_METRIC_FAIL,
      payload: error.response?.data?.message || error.message,
    });
    throw error;
  }
};

export const updateBlogMetric = (payload) => async (dispatch) => {
  dispatch({ type: UPDATE_BLOG_METRIC_REQUEST });
  try {
    const response = await axios.patch(`${API_URL}/update`, payload, getAuthConfig());
    dispatch({ type: UPDATE_BLOG_METRIC_SUCCESS, payload: response.data });
    return response; // Add return here
  } catch (error) {
    dispatch({
      type: UPDATE_BLOG_METRIC_FAIL,
      payload: error.response?.data?.message || error.message,
    });
    throw error;
  }
};

export const deleteBlogMetric = (payload) => async (dispatch) => {
  dispatch({ type: DELETE_BLOG_METRIC_REQUEST });
  try {
    const response = await axios.post(`${API_URL}/delete`, payload, getAuthConfig());
    dispatch({ type: DELETE_BLOG_METRIC_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({
      type: DELETE_BLOG_METRIC_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};
